export const SCORECARD_COMMENT_MIN_LENGTH = 30

export const SCORECARD_COMMENT_HELPER =
  'The reviewer stays accurate because of scorecard feedback like yours. Please tell us how the exam went for this subject — what showed up, what felt hard, and what you wish you’d practiced more.'

const PLACEHOLDERS = new Set([
  'n/a',
  'na',
  'n.a.',
  'n.a',
  'none',
  '-',
  '.',
])

/**
 * Client-side scorecard comment validation (ENG-41).
 * Returns an inline error string, or null when the comment is valid.
 */
export function scorecardCommentError(value) {
  const trimmed = String(value == null ? '' : value).trim()

  if (!trimmed) {
    return 'Please add a comment about your exam experience for this subject.'
  }

  const normalized = trimmed.toLowerCase()
  if (PLACEHOLDERS.has(normalized) || !/[a-z0-9]/i.test(trimmed)) {
    return 'Please write a real comment instead of N/A or similar.'
  }

  if (trimmed.length < SCORECARD_COMMENT_MIN_LENGTH) {
    return `Please write at least ${SCORECARD_COMMENT_MIN_LENGTH} characters about how the exam went for this subject.`
  }

  return null
}
